import { requireContractAccess } from '@/lib/route-guards';
import { registryItemQueryOptions } from '@/queryOptions';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/registry/contracts/$contractId/')({
  validateSearch: (search: Record<string, unknown>) => ({
    version: search.version as string | undefined,
  }),
  context: ({ params }) => ({
    getBreadcrumbData: () => ({
      id: params.contractId,
      translationKey: null,
    }),
  }),
  beforeLoad: ({ params, context, search }) => {
    requireContractAccess(context);
    return context.queryClient.ensureQueryData(registryItemQueryOptions(params.contractId, search.version));
  },
  head: () => {
    return {
      meta: [
        {
          title: 'Contract Details - OPAZ E-Service Portal',
        },
      ],
    };
  },
});
